import { useState } from 'react';
import { Search, MapPin } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';
interface SearchBarProps {
  placeholder?: string;
  onSearch?: (query: string) => void;
  onNearMe?: () => void;
  className?: string;
}
const SearchBar = ({
  placeholder = "Search shops nearby...",
  onSearch,
  onNearMe,
  className = ""
}: SearchBarProps) => {
  const [query, setQuery] = useState('');
  const {
    toast
  } = useToast();
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (onSearch && query.trim()) {
      onSearch(query);
    }
  };
  const handleNearMe = () => {
    if (onNearMe) {
      onNearMe();
    } else {
      navigator.geolocation.getCurrentPosition(position => {
        toast({
          title: "Location detected",
          description: "Showing shops near your location"
        });
        console.log("Near Me clicked:", position.coords);
      }, error => {
        toast({
          variant: "destructive",
          title: "Location access denied",
          description: "Please enable location services to use this feature"
        });
        console.error("Geolocation error:", error);
      });
    }
  };
  return <div className={`relative w-full ${className}`}>
      <form onSubmit={handleSubmit} className="relative">
        <div className="relative">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <Search className="h-5 w-5 text-gray-400" />
          </div>
          <input type="text" className="input-field pl-10 pr-20 py-3 rounded-full shadow-sm focus:shadow-md transition-all" placeholder={placeholder} value={query} onChange={e => setQuery(e.target.value)} />
          
        </div>
      </form>
    </div>;
};
export default SearchBar;